export default {
  isSesionActive: Boolean(localStorage.getItem("token")),
  stateLogin: {
    success: "",
    message: ""
  },
}